import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

const ConfirmationDialog = ({ openDialog, handleOkayClick, handleCancelClick, title, description }) => {
    const handleButtonOkayClick = () => {
        handleOkayClick();
    };
    const handleButtonCancelClick = () => {
        handleCancelClick();
    };
    return (        
            <Dialog
                open={openDialog}
                //onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {title}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                    {description}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleButtonCancelClick}>Cancel</Button>
                    <Button onClick={handleButtonOkayClick} autoFocus>
                        Okay
                    </Button>
                </DialogActions>
            </Dialog>
    );
};

export default ConfirmationDialog;